module.exports = __webpack_public_path__ + "img/forgot-password-email-sent.4a0281db.webp";